<template>
  <el-dialog
    v-if="visible"
    v-el-drag-dialog
    :visible.sync="visible"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    append-to-body
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="$t('baseData.terminalmanage.terminalInfo.seeHistory')"
      @close="closeDialog"
    />
    <div :style="{height:'50vh'}">
      <el-scrollbar style="height:100%" wrap-class="default-scrollbar__wrap">
        <vue-linetitle
          :icon-config="{icon:'approve-car'}"
          :title="`${$t('carManagement.boundHistory')}`">
          <div style="min-height: 40px">
            <el-timeline style="padding-left: 160px" v-for="(itemArray, index) in list" :key="index">
              <el-timeline-item
                v-for="(item, i) in itemArray"
                :key="i"
                :timestamp="item.createdOn"
                color="#409eff"
                placement="top"
                hide-timestamp >
                <p style="padding: 3px 0;margin: 0">
                  <span style="color: #909399"> {{ item.createdOn }} </span>
                </p>
                <div
                  v-if="item.type==0"
                  :style="{'margin-left': '-160px','margin-top': itemArray.length>1 ? '18px':'-15px'}">
                  <vue-licenseplate
                    :types="0"
                    :licensepalte="item.licensePlate"
                    :area="item.areaName"
                  />
                  <div class="vin" :class="{ single: itemArray.length == 1 }">
                    <p><label>{{$t('carManagement.regVin')}}:</label>{{item.vinNo}}</p>
                    <p><label>{{$t('carManagement.ecuVin')}}:</label>{{item.ecuVin}}</p>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
           <div v-show="list.length==0" style="text-align: center;margin-top: 30px">{{ $t('book.historyTrack.noData') }}</div>
          </div>
          
        </vue-linetitle>
      </el-scrollbar>
    </div>
  </el-dialog>
</template>
<script>
// 混入
import { pagingMixin } from '@/mixins/table'
import { tableStyle } from '@/mixins/tableStyle'
// request

import { getHistory } from '@/api/obdDevice/manage'
// 组件
export default {
  name: 'HistoryDialog',
  mixins: [pagingMixin, tableStyle],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: Object
  },
  data() {
    return {
      list: []
    }
  },
  watch: {
    visible(e1) {
      if (e1) {
        this.listLoad()
      }
    }
  },
  methods: {
    listLoad() {
      if (!this.visible) {
        return
      }
      getHistory({ terminalId: this.data.terminalId }).then(({ data }) => {
        const list = []
        if (data.code === 0) {
          const result = data.data || []
          result.forEach((item, i)=>{
            let arr = []
            arr.push({
              createdOn: item.startTime,
              licensePlate: item.licensePlate,
              note: item.bindNote,
              areaName: item.areaName,
              type: 0,
              vinNo: item.vinNo,
              ecuVin: item.ecuVin
            })
            if(item.endTime) {
              arr.push({
                createdOn: item.endTime,
                licensePlate: item.licensePlate,
                note: item.unbindNote,
                areaName: item.areaName,
                type: 1
              })
            } else if (i === 0) {
              // 最后一次绑定且未解绑的OBD显示当前ecuVin
              arr[0].ecuVin = this.data.ecuVin
            }
            list.push(arr)
          })
        }
        this.list = list
      })
    },

    // 关闭dialog
    closeDialog() {
      this.$emit('update:visible', false)
    }

  }
}
</script>

<style lang="scss" scoped>
.vin {
  position: absolute;
  left: 28px;
  top: 45px;

  &.single {
    top: 18px;
  }
  p {
    margin: 0;
    line-height: 1.5;
  }
  label {
    display: inline-block;
    width: 200px;
  }
}
</style>
